module.exports = __webpack_public_path__ + "logo_ies-4dcbb37abcdae5b2fa9a0f59ea373149.png";